export enum PageLayout {
    Default = 'default',
    Public = 'public',
    Admin = 'admin',
    Blank = 'blank',
    Client = 'client',
    ClientDashboard = 'client-dashboard',
    Vendor = 'vendor',
}
